/**
 * Quick Deck Feature Flag & Configuration
 * Set feature.quickdeck = false to disable the module entirely
 */

export const FEATURE_FLAGS = {
  quickdeck: true, // Set to false to disable Quick Deck
};

// Quick Deck Desires (Level 1)
export const DESIRES = [
  { id: 'visit', icon: '🏛️', labelKey: 'quickdeck.desires.visit' },
  { id: 'discover', icon: '🧭', labelKey: 'quickdeck.desires.discover' },
  { id: 'eat', icon: '🍽️', labelKey: 'quickdeck.desires.eat' },
  { id: 'drink', icon: '🍸', labelKey: 'quickdeck.desires.drink' },
  { id: 'party', icon: '🎉', labelKey: 'quickdeck.desires.party' },
  { id: 'chill', icon: '🌿', labelKey: 'quickdeck.desires.chill' },
];

// Constraints by desire (Level 2)
export const CONSTRAINTS_BY_DESIRE = {
  visit: {
    time: ['30m', '1h', '2h', '3h'],
    budget: ['€', '€€', '€€€'],
    distance: ['close', 'medium'],
    vibe: ['indoor', 'outdoor', 'open_now'],
  },
  discover: {
    time: ['1h', '2h', '3h', '6h'],
    budget: ['€', '€€'],
    distance: ['close', 'medium', 'far'],
    vibe: ['quiet', 'lively', 'outdoor', 'open_now'],
  },
  eat: {
    time: ['30m', '1h', '2h'],
    budget: ['€', '€€', '€€€'],
    distance: ['close', 'medium'],
    vibe: ['quick', 'cozy', 'trendy', 'open_now'],
  },
  drink: {
    time: ['1h', '2h', '3h'],
    budget: ['€', '€€', '€€€'],
    distance: ['close', 'medium'],
    vibe: ['quiet', 'lively', 'rooftop', 'open_now'],
  },
  party: {
    time: ['2h', '3h', '6h'],
    budget: ['€€', '€€€'],
    distance: ['close', 'medium'],
    vibe: ['club', 'bar', 'live_music', 'open_now'],
  },
  chill: {
    time: ['30m', '1h', '2h', '3h'],
    budget: ['€', '€€'],
    distance: ['close', 'medium'],
    vibe: ['quiet', 'nature', 'cafe', 'open_now'],
  },
};

// Quick Presets
export const QUICK_PRESETS = {
  around_me: { distance: 'close', time: '1h' },
  three_hours: { time: '3h' },
};

// Analytics event names
export const ANALYTICS_EVENTS = {
  VIEW: 'quickdeck_view',
  DESIRE_SELECTED: 'quickdeck_desire_selected',
  CONSTRAINT_TOGGLED: 'quickdeck_constraint_toggled',
  GENERATE_CLICKED: 'quickdeck_generate_clicked',
  QUICKACTION_CLICKED: 'quickdeck_quickaction_clicked',
  RESULT_GO: 'quickdeck_result_go',
  RESULT_SAVE: 'quickdeck_result_save',
  RESULT_SWAP: 'quickdeck_result_swap',
};
